import axios from 'axios'

async function getAllSku () {
  return axios.get('/admin/sku')
}

async function updateSku () {
  return axios.put('/admin/sku')
}

export default {
  getAllSku,
  updateSku
}



// WEBPACK FOOTER //
// ./src/api/sku.js